export const INACTIVE_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours

export const itemTypes = [
    { id: "w", label: "Music", color: "#396A93" },
    { id: "e", label: "Talk", color: "#99BBD6" },
    { id: "j", label: "Journalism", color: "#F0E68C" },
    { id: "n", label: "News", color: "#519872" },
    { id: "c", label: "Commercial", color: "#D5573B" },
    { id: "b", label: "Break", color: "#99BBD6" },
];
export const daysPerspectives = [
    { perspective: "All", days: [0, 1, 2, 3, 4, 5, 6] },
    { perspective: "Workdays", days: [0, 1, 2, 3, 4] },
    { perspective: "Weekend", days: [5, 6] },
];

export const playlistPerspectives = [
    { perspective: "All", categoryTypes: [1, 2, 3, 4, 5] },
    { perspective: "Playlist", categoryTypes: [1, 2] },
    { perspective: "Backpool", categoryTypes: [3, 4, 5] },
];

export const PLAP_CATEGORY_SIZES = {
    unlimited: "Unlimited",
    keep: "Keep same",
    target: "Set target",
};

export const PLAP_CATEGORY_RULE_TYPES = {
    up: "Up",
    down: "Down",
    out: "Out",
};

export const PLAP_CONDITION_VARIABLES = {
    score: "Song Score",
    score_trend: "Song Score Trend",
    burn: "Burn",
    burn_trend: "Burn Trend",
    spins: "Spins",
};
export const PLAP_CONDITION_OPERATORS = {
    "<": "<",
    "<=": "<=",
    ">": ">",
    ">=": ">=",
    "==": "=",
};

export const PLAP_CONDITION_TREND_VALUES = {
    negative: "Negative",
    stable: "Stable",
    positive: "Positive",
};

export const PLAP_CONDITION_TREND_OPERATORS = {
    "<=": "At Most",
    ">=": "At Least",
};
